// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ul {
    list-style-type: none;
    padding: 0;
  }
 .work .experience {
  float: left;
}
 .work .experience small {
  display: block;
  opacity: 0.7;
}
 .work .experience ul li {
  position: relative;
  margin-left: 15px;
  padding-left: 25px;
  padding-bottom: 15px;
}
 .work .experience ul li:hover::before {
  animation: circle 1.2s infinite;
}
 .work .experience ul li:hover span {
  color: #27c17e;
}
@keyframes circle {
  from {
    box-shadow: 0 0 0 0px #27c17e;
  }
  to {
    box-shadow: 0 0 0 6px rgba(255, 255, 255, 0);
  }
}
 .work .experience ul li:first-of-type::before {
  width: 10px;
  height: 10px;
  left: 1px;
}
 .work .experience ul li:last-of-type {
  padding-bottom: 3px;
}
 .work .experience ul li:last-of-type::after {
  border-radius: 1.5px;
}
 .work .experience ul li::before,
 .work .experience ul li::after{
  content: "";
  display: block;
  position: absolute;
}
 .work .experience ul li::before{
  width: 7px;
  height: 7px;
  border: 3px solid #fff;
  background: #27c17e;
  border-radius: 50%;
  left: 3px;
  z-index: 1;
}
 .work .experience ul li::after {
  width: 3px;
  height: 100%;
  background: #fff;
  left: 5px;
  top: 0;
}
 .work .experience ul li span{
  transition-duration: 0.3s;
}
 .work .experience {
  width: 48%;
  background: #f1fcfc;
  padding: 15px;
  margin: 0 4% 15px 0;
}`, "",{"version":3,"sources":["webpack://./src/components/layouts/work.css"],"names":[],"mappings":"AAAA;IACI,qBAAqB;IACrB,UAAU;EACZ;CACD;EACC,WAAW;AACb;CACC;EACC,cAAc;EACd,YAAY;AACd;CACC;EACC,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,oBAAoB;AACtB;CACC;EACC,+BAA+B;AACjC;CACC;EACC,cAAc;AAChB;AACA;EACE;IACE,6BAA6B;EAC/B;EACA;IACE,4CAA4C;EAC9C;AACF;CACC;EACC,WAAW;EACX,YAAY;EACZ,SAAS;AACX;CACC;EACC,mBAAmB;AACrB;CACC;EACC,oBAAoB;AACtB;CACC;;EAEC,WAAW;EACX,cAAc;EACd,kBAAkB;AACpB;CACC;EACC,UAAU;EACV,WAAW;EACX,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;EACT,UAAU;AACZ;CACC;EACC,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,SAAS;EACT,MAAM;AACR;CACC;EACC,yBAAyB;AAC3B;CACC;EACC,UAAU;EACV,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB","sourcesContent":["ul {\n    list-style-type: none;\n    padding: 0;\n  }\n .work .experience {\n  float: left;\n}\n .work .experience small {\n  display: block;\n  opacity: 0.7;\n}\n .work .experience ul li {\n  position: relative;\n  margin-left: 15px;\n  padding-left: 25px;\n  padding-bottom: 15px;\n}\n .work .experience ul li:hover::before {\n  animation: circle 1.2s infinite;\n}\n .work .experience ul li:hover span {\n  color: #27c17e;\n}\n@keyframes circle {\n  from {\n    box-shadow: 0 0 0 0px #27c17e;\n  }\n  to {\n    box-shadow: 0 0 0 6px rgba(255, 255, 255, 0);\n  }\n}\n .work .experience ul li:first-of-type::before {\n  width: 10px;\n  height: 10px;\n  left: 1px;\n}\n .work .experience ul li:last-of-type {\n  padding-bottom: 3px;\n}\n .work .experience ul li:last-of-type::after {\n  border-radius: 1.5px;\n}\n .work .experience ul li::before,\n .work .experience ul li::after{\n  content: \"\";\n  display: block;\n  position: absolute;\n}\n .work .experience ul li::before{\n  width: 7px;\n  height: 7px;\n  border: 3px solid #fff;\n  background: #27c17e;\n  border-radius: 50%;\n  left: 3px;\n  z-index: 1;\n}\n .work .experience ul li::after {\n  width: 3px;\n  height: 100%;\n  background: #fff;\n  left: 5px;\n  top: 0;\n}\n .work .experience ul li span{\n  transition-duration: 0.3s;\n}\n .work .experience {\n  width: 48%;\n  background: #f1fcfc;\n  padding: 15px;\n  margin: 0 4% 15px 0;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
